import { render, staticRenderFns } from "./ConsumeRecord.vue?vue&type=template&id=389b8000&scoped=true&"
import script from "./ConsumeRecord.vue?vue&type=script&lang=js&"
export * from "./ConsumeRecord.vue?vue&type=script&lang=js&"
import style0 from "./ConsumeRecord.vue?vue&type=style&index=0&id=389b8000&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389b8000",
  null
  
)

export default component.exports